import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/issueLimitLists'
import Component from 'components/IssueLimitLists'

export default createListViewContainer({ actions, selectors: selectors.issueLimitLists })(Component)
